// 028A-1 — Curva de Crecimiento Fenton 2003 para prematuros (2m antes de
// término hasta las ~2 meses corregidos) — ver PLAN.md Serie 028 Sub-tanda D.
// Trío peso/longitud/perímetro cefálico + edad gestacional al nacer
// REQUERIDA (sin ella no hay eje X posible: Fenton grafica contra edad
// postmenstrual, ver paciente/curvaPercentilPorEdad.ts).
import { crearFormularioCurvaCrecimiento } from './curvaCrecimiento';

export const Formulario028A1 = crearFormularioCurvaCrecimiento({
  claveI18n: 'f028a1',
  incluirPerimetroCefalico: true,
  incluirEdadGestacionalAlNacer: 'requerido',
  curvasPdf: 'fenton',
});
